import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTabletStyle0 = gravityIconIndividualCss;

const GravityIconTablet = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '8cdefcae221d4239c45d8c51f2e0b6363f9570d7', color: this.color, size: this.size }, h("svg", { key: '0b3cbdc663c3cebd84cb0019a9d5431da0c40dea', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '09dd23866a0730923b706c97d6b8e47f2cc978d2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-14a.5.5 0 0 0-.5-.5h-11ZM11 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4.5-3h-9V4.5h9V14Z", fill: "currentColor" }))));
    }
};
GravityIconTablet.style = GravityIconTabletStyle0;

export { GravityIconTablet as gravity_icon_tablet };

//# sourceMappingURL=gravity-icon-tablet.entry.js.map